module.exports = __webpack_public_path__ + "img/wamp.b5aef005.png";